import PublicPageTemplate from '../../components/PublicPageTemplate/PublicPageTemplate';

function GdadPrivacyNoticePage() {
  return (
    <PublicPageTemplate
      title="Privacy Notice for Government Digital and Data Assessment Assessment"
      fullWidth
    >
      <p className="govuk-body">Last updated: 13 March 2026</p>
      <p className="govuk-body">
        This notice sets out how we will use your personal data, and your rights. It is made under
        Articles 13 and/or 14 of the UK General Data Protection Regulation (UK GDPR).
      </p>

      <h2 className="govuk-heading-m">YOUR DATA</h2>

      <h3 className="govuk-heading-s">Purpose</h3>
      <p className="govuk-body">The purposes for which we are processing your personal data are</p>
      <p className="govuk-body">
        to conduct the Government Digital and Data Assessment (GDAD) and facilitate the digital
        &amp; data allowances being paid to Cabinet Office staff.
      </p>
      <p className="govuk-body">
        The GDAD assessment is not mandatory; however, Cabinet Office Employees will complete the
        GDAD assessment if:
      </p>
      <ul className="govuk-list govuk-list--bullet">
        <li>they have moved into a GDAD role and have never received a GDAD allowance before,</li>
        <li>have never previously applied but want to be considered for a digital allowance, or</li>
        <li>if they think their skill level/ proficiency has increased; however,</li>
      </ul>
      <p className="govuk-body">
        If an individual is currently in receipt of a GDAD allowance and does not think their
        proficiency rating has changed, they will not submit a GDAD assessment.
      </p>
      <p className="govuk-body">Specific processing purposes include:</p>
      <ul className="govuk-list govuk-list--bullet">
        <li>For managing a civil service profession or function</li>
        <li>For statistical analysis</li>
      </ul>

      <h3 className="govuk-heading-s">The data</h3>
      <p className="govuk-body">We will process the following personal data:</p>
      <ul className="govuk-list govuk-list--bullet">
        <li>Name</li>
        <li>Performance details</li>
        <li>Email address</li>
        <li>Employment details (start date or profession etc)</li>
        <li>Location data</li>
        <li>Job title or grade</li>
      </ul>

      <h3 className="govuk-heading-s">Legal basis of processing</h3>
      <p className="govuk-body">
        The legal basis for processing your personal data is where processing is necessary for our
        legitimate interests or those of a third party.
      </p>

      <h3 className="govuk-heading-s">Recipients</h3>
      <p className="govuk-body">
        Your personal data will be shared by us with GOV.UK Notify, GRID (Amazon Web Services),
        Google and our ERP provider.
      </p>

      <h3 className="govuk-heading-s">Retention</h3>
      <p className="govuk-body">
        Your personal data will be kept by us for 2 years. Anonymised data will be retained for 5
        for statistics and research purposes, to help with high level workforce planning.
      </p>

      <h2 className="govuk-heading-m">YOUR RIGHTS</h2>
      <p className="govuk-body">
        You have the right to request information about how your personal data are processed, and to
        request a copy of that personal data.
      </p>
      <p className="govuk-body">
        You have the right to request that any inaccuracies in your personal data are rectified
        without delay.
      </p>
      <p className="govuk-body">
        You have the right to request that any incomplete personal data are completed, including by
        means of a supplementary statement.
      </p>
      <p className="govuk-body">
        You have the right to request that your personal data are erased if there is no longer a
        justification for them to be processed.
      </p>
      <p className="govuk-body">
        You have the right in certain circumstances (for example, where accuracy is contested) to
        request that the processing of your personal data is restricted.
      </p>
      <p className="govuk-body">
        You have the right to object to the processing of your personal data
      </p>

      <h2 className="govuk-heading-m">INTERNATIONAL TRANSFERS</h2>
      <p className="govuk-body">
        As your personal data is stored on our Corporate IT infrastructure, and shared with our data
        processors, it may be transferred and stored securely outside the UK. Where that is the case
        it will be subject to equivalent legal protection through an adequacy decision, reliance on
        Standard Contractual Clauses, or reliance on a UK International Data Transfer Agreement.
      </p>

      <h2 className="govuk-heading-m">COMPLAINTS</h2>
      <p className="govuk-body">
        If you consider that your personal data has been misused or mishandled, you may make a
        complaint to the Information Commissioner, who is an independent regulator. The Information
        Commissioner can be contacted at: Information Commissioner&apos;s Office, Wycliffe House,
        Water Lane, Wilmslow, Cheshire, SK9 5AF, or 0303 123 1113, or icocasework@ico.org.uk. Any
        complaint to the Information Commissioner is without prejudice to your right to seek redress
        through the courts.
      </p>

      <h2 className="govuk-heading-m">CONTACT DETAILS</h2>
      <p className="govuk-body">
        The data controller for your personal data is the Cabinet Office. The contact details for
        the data controller are: Cabinet Office, 70 Whitehall, London, SW1A 2AS, or 0207 276 1234,
        or you can use this webform.
      </p>
      <p className="govuk-body">
        The contact details for the data controller&apos;s Data Protection Officer are:
        <a className="govuk-link" href="mailto:dpo@cabinetoffice.gov.uk">
          {' '}
          dpo@cabinetoffice.gov.uk
        </a>
        .
      </p>
      <p className="govuk-body">
        The Data Protection Officer provides independent advice and monitoring of Cabinet Office&apos;s
        use of personal information.
      </p>
    </PublicPageTemplate>
  );
}

export default GdadPrivacyNoticePage;
